module.exports = __webpack_public_path__ + "static/img_2.02822b7f.png";